class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  // A closed <details> never lays out its non-summary content, no matter
  // what opacity/display an author stylesheet sets on it - only setting the
  // native `open` attribute (exactly like a click does) makes the mega menu
  // panel exist at all, so hover has to drive that attribute directly
  // instead of trying to fade the panel in purely with CSS.
  onMouseEnter() {
    if (!window.matchMedia('(hover: hover)').matches) return;
    clearTimeout(this.hoverCloseTimeout);
    // One panel at a time: coming from a neighbouring item, close its panel at
    // once instead of letting it linger (and overlap) for the close delay.
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu === this) return;
      clearTimeout(menu.hoverCloseTimeout);
      menu.close();
    });
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
  }

  onMouseLeave() {
    if (!window.matchMedia('(hover: hover)').matches) return;
    // The panel starts at the bottom of the header, below the logo, so there is
    // a gap between the item and the panel. The invisible hover bridge in
    // custom-header.css covers most of it; this delay is the safety net for a
    // slow or diagonal move, and it only closes if the pointer is really gone.
    this.hoverCloseTimeout = setTimeout(() => {
      if (!this.matches(':hover')) this.close();
    }, 350);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
